import { Form } from 'react-bootstrap';
import type { CSSProperties } from 'react';
import { useEffect, useState } from 'react';

type Props = {
  separator: string;
  valueFromModel: unknown;
  onCommit: (list: string[]) => void;
  style?: CSSProperties;
};

function joinedFromParam(valueFromModel: unknown, separator: string): string {
  if (typeof valueFromModel === 'number') {
    return String(valueFromModel);
  }
  if (Array.isArray(valueFromModel)) {
    return valueFromModel.join(separator);
  }
  return '';
}

export function PlanningTextListInput({ separator, valueFromModel, onCommit, style }: Props) {
  const joinedProp = joinedFromParam(valueFromModel, separator);
  const [text, setText] = useState(joinedProp);

  useEffect(() => {
    setText(joinedProp);
  }, [joinedProp]);

  return (
    <Form.Control
      type="text"
      spellCheck={false}
      style={style}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={(e) => {
        const list = e.target.value
          .split(separator)
          .map((item: string) => item.trim())
          .filter((item: string) => item.length > 0);
        onCommit(list);
      }}
    />
  );
}
